import * as React from "react";
import { ImageProps, VideoProps } from "../types";
import Image from "next/image";
import CTALink from "@/components/CTA/ctaLink";
import VideoPlayer from "@/components/VideoPlayer";
import validateHex from "@/utils/functions/validateHex";

export default function ImageRight({
  children,
  imageurl,
  imagetitle,
  videourl,
  height = 280,
  width = 342,
  useContainer = true,
  responsiveImage = false,
  overrideBGColor = false,
  reverseVertical = true,
  accentColor = "",
  className = "",
}: ImageProps &
  VideoProps & { useContainer?: boolean; overrideBGColor?: boolean }) {
  const hasCTALink = React.Children.toArray(children).some((child) => {
    if (React.isValidElement(child)) {
      const element = child as React.ReactElement<{
        children?: React.ReactNode;
      }>;
      if (React.isValidElement(element.props.children)) {
        const childElement = element.props.children;
        return childElement.type === CTALink;
      }
    }
    return false;
  });

  if (!hasCTALink) {
    return (
      <div
        className={`flex py-8 ${reverseVertical ? "flex-col-reverse" : "flex-col"} ${responsiveImage ? "lg:flex-row" : "md:flex-row"} ${useContainer ? "container" : ""} items-center ${className}`}
      >
        <div
          className={`content-block-children-container min-w-[300px] md:mr-12 ${responsiveImage ? "basis-1/2" : ""}`}
        >
          {children}
        </div>
        <div
          className={`content-block-image-container flex justify-center ${responsiveImage ? "basis-1/2" : ""}`}
        >
          {imageurl ? (
            <div
              className="flex items-center"
              style={{
                height: responsiveImage ? "100%" : height,
                width: responsiveImage ? "100%" : width,
              }}
            >
              {videourl ? (
                <VideoPlayer
                  videoUrl={videourl}
                  title={imagetitle}
                  videoThumbnail={imageurl}
                  videoContainerClassName="w-[342px] h-[280px] flex items-center"
                  videoClassName="w-[342px] h-[280px]"
                />
              ) : (
                <Image
                  width={width}
                  height={height}
                  src={imageurl}
                  alt={imagetitle || ""}
                  className={`block object-cover w-full h-auto ${accentColor ? "pb-4" : ""}`}
                  style={{
                    backgroundColor: accentColor
                      ? validateHex(accentColor)
                      : "none",
                  }}
                />
              )}
            </div>
          ) : null}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`${overrideBGColor ? "bg-transparent" : "bg-white"} flex flex-col md:flex-row ${useContainer ? "container" : ""} items-center ${className}`}
      >
        <div className="content-block-children-container relative w-full h-auto px-4">
          {children}
        </div>
        {imageurl ? (
          <div
            className="content-block-image-container flex items-center"
            style={{
              height: responsiveImage ? "100%" : height,
              width: responsiveImage ? "100%" : width,
            }}
          >
            {videourl ? (
              <VideoPlayer
                videoUrl={videourl}
                title={imagetitle}
                videoThumbnail={imageurl}
                videoContainerClassName="w-[342px] h-[280px] flex items-center"
                videoClassName="w-[342px] h-[280px]"
              />
            ) : (
              <Image
                width={width}
                height={height}
                src={imageurl}
                alt={imagetitle || ""}
                className={`block object-cover w-full h-auto ${accentColor ? "pb-4" : ""}`}
                style={{
                  backgroundColor: accentColor
                    ? validateHex(accentColor)
                    : "none",
                }}
              />
            )}
          </div>
        ) : null}
      </div>
    );
  }
}
